import { callApiToServer } from '../../callApi';

export async function editCurrency(
  authtoken,
  currencyObject
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
    
    currencyObject.currencyId = currencyObject.id
    let body = JSON.stringify(currencyObject);
  
    let endUrl = "v1/auth/edit-currency";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
